export default "__VITE_ASSET__DaLED8Xy__"